var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('CardOrderPenunjang',{attrs:{"register":_vm.register,"rm":_vm.rm},on:{"pageTab":_vm.showTab}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }